module.exports = __webpack_public_path__ + "static/media/LoyalityProgramsCards2.604ed653.png";